import React from "react";
import classNames from "classnames";
import { useTranslation } from "react-i18next";

import { Props } from "./types";
import styles from "./styles.scss";

function ToggleButton({ isActive, isDisable, toggle }: Props) {
  const { t } = useTranslation();

  return (
    <div
      onClick={() => !isDisable && toggle()}
      className={classNames(styles.toggleButton, {
        [styles.disable]: isDisable,
      })}
    >
      <div className={classNames(styles.thumb, { [styles.right]: isActive })} />
      <div className={classNames(styles.row, { [styles.selected]: !isActive })}>
        <p className={styles.label}>{t("timesheetPage.toggle.personal")}</p>
      </div>
      <div className={classNames(styles.row, { [styles.selected]: isActive })}>
        <p className={styles.label}>{t("timesheetPage.toggle.team")}</p>
      </div>
    </div>
  );
}

export { ToggleButton };
